module.exports = __webpack_public_path__ + "media/assets/images/confinus-logo-1fd32e180fdfd14986c159f89c664d30.png";